import React from 'react'
import { Menu } from '@headlessui/react'

const SelectOrder = ({ updateSorting, activeSorting, options }) => {
  if (!options) return null
  const activeOption = options.find((item) => item.type === activeSorting?.type)
  return (
    <div className="dropdown">
      <Menu>
        {({ open }) => (
          <>
            <Menu.Button
              className={`btn btn-outline-secondary dropdown-toggle ${
                open ? 'open' : ''
              }`}
            >
              {activeOption?.label}
            </Menu.Button>
            <Menu.Items className="dropdown-menu show">
              {options?.map((option, i) => (
                <Menu.Item key={option?.label + i}>
                  <div className="">
                    <button
                      className="dropdown-item"
                      onClick={() => updateSorting(option)}
                    >
                      <input
                        type="checkbox"
                        onChange={() => updateSorting(option)}
                        checked={activeOption?.type === option?.type}
                        name={option?.label}
                        value={option?.type}
                      />
                      {option?.label}
                    </button>
                  </div>
                </Menu.Item>
              ))}
            </Menu.Items>
          </>
        )}
      </Menu>
    </div>
  )
}

export default SelectOrder
